import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Robustand = () => {
  return (
    <div className="Robustand p-100" style={{ backgroundColor: "#F9F9F9" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
            <h2>Impact of Cloud Support Services on Industrial Sectors</h2>
            <p>
              We have witnessed clients in diverse sectors yield the following
              key advantages of configuring IT support and cloud services in
              their production-sensitive and service-centric businesses.
            </p>
          </Col>
          <Col xs={12} md={6} lg={7} xl={6} xxl={6} className="offset-xl-1">
            <div className="robustscroll">
              <div className="robust-box">
                <div className="robust-content">
                  <h4>Healthcare</h4>
                  <p>
                    Cloud infrastructure helps secure the HER and assists
                    healthcare organizations in meeting patient data management
                    regulations like HIPAA. It also improves the provision of
                    connected services like remote telemedicine and online
                    patient care initiatives.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Real Estate</h4>
                  <p>
                    Cloud streamlines prop-tech by facilitating and automating
                    key real estate KPIs like maintenance scheduling,
                    decision-making, tenant management and transaction security.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Logistics & Supply Chain</h4>
                  <p>
                    Cloud-based logistics setups improve efficiencies by
                    protecting data, minimizing downtimes, reducing delays and
                    facilitating workflows.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Manufacturing</h4>
                  <p>
                    Cloud setups and their regular maintenance improve
                    operational efficiency in manufacturing by supporting KPIs
                    like production planning, material management and
                    integrating them with quality controls and financial
                    results.
                  </p>
                </div>
                <div className="robust-content">
                  <h4>Ecommerce and Retail</h4>
                  <p>
                    Cloud can handle varying demand, supply and traffic during
                    seasons and non-seasons. With cloud infrastructure and its
                    regular maintenance, retail businesses can automate and
                    achieve their success metrics, revenue targets and expansion
                    objectives.
                  </p>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Robustand;
